import { formatSecondsToISO8601 } from 'helpers'
import { Helmet } from 'react-helmet'
import Text from './text.json'

export default ({ PresentationVideo, Title, courseCode, PublicationDate }) =>
  <Helmet>
    <script type='application/ld+json'>
      {
        `
          {
              "@context": "https://schema.org",
              "@type": "VideoObject",
              "name": "${Text.namePrefix} ${Title}",
              "description": "${Text.descriptionPrefix} ${Title}",
              "thumbnailUrl": "${Text.backgroundPlayerLink}/${courseCode}/${PresentationVideo.StreamName}${Text.backgroundPlayerLinkExtension}",
              "uploadDate": "${PublicationDate}",
              "duration": "${formatSecondsToISO8601(PresentationVideo.Duration)}",
              "contentUrl": "${PresentationVideo.Link.Desktop}",
              "isAccessibleForFree": true
          }
        `
      }
    </script>
  </Helmet>
